// extracted by mini-css-extract-plugin
export default {"Loader_basic":"Loader_Loader_basic__HyEp-","sk-rotateplane":"Loader_sk-rotateplane__LTmWU","Loader_external":"Loader_Loader_external__Uo-gH"};